export default "__VITE_ASSET__Cump4YON__"